
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/careers/[...slug]",
      function () {
        return require("private-next-pages/careers/[...slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/careers/[...slug]"])
      });
    }
  